import { Button, Stack, Typography } from '@mui/material';
import { PlusIcon } from '@schooly/style';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export const StaffEmptyStub: FC = () => {
  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <Typography variant="h1" textAlign="center" mb={1} maxWidth={417}>
        <FormattedMessage id="staff-Empty-title" />
      </Typography>

      <Typography variant="h3" mb={3}>
        <FormattedMessage id="staff-Empty-subtitle" />
      </Typography>

      <Link to="/staff/new">
        <Button startIcon={<PlusIcon />}>
          <FormattedMessage id="staff-NewStaff" />
        </Button>
      </Link>
    </Stack>
  );
};
